import React from "react";
import { useTranslation } from "react-i18next";
import { Check, X } from "lucide-react";
import { Button } from "@core/index";

interface SaveCancelButtonsProps {
  onSave: () => void;
  onCancel: () => void;
  className?: string;
}

export const SaveCancelButtons: React.FC<SaveCancelButtonsProps> = ({
  onSave,
  onCancel,
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <div className={`flex gap-2 w-full sm:w-auto ${className}`}>
      <Button
        onClick={onCancel}
        size="md"
        rounded="lg"
        bgColor="hover:bg-gray-100 dark:hover:bg-gray-700"
        textColor="text-gray-700 dark:text-gray-300"
        className="flex-1 sm:flex-initial"
      >
        <X size={16} className="mr-2" />
        {t("common.cancel")}
      </Button>
      <Button
        onClick={onSave}
        size="md"
        rounded="lg"
        bgColor="bg-rose-500 hover:bg-rose-600"
        textColor="text-white"
        className="shadow-sm flex-1 sm:flex-initial"
      >
        <Check size={16} className="mr-2" />
        {t("common.save")}
      </Button>
    </div>
  );
};
